"use client";

import { useMemo } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode } from "swiper/modules";

const BASE_BUTTON_CLASS = "px-6 py-1.5 text-sm rounded-full transition-all bg-black/20 border font-dana-regular flex-shrink-0";
const ACTIVE_BUTTON_CLASS = "bg-[#101011] border-red-stroke text-white shadow-[0_0_15px_rgba(215,19,51,0.15)]";
const INACTIVE_BUTTON_CLASS = "border-transparent text-mute hover:text-white hover:border-white/20";

const getItemLabel = (item) => (typeof item === "string" ? item : item?.label || item?.name || "");
const getItemValue = (item) => (typeof item === "string" ? item : item?.id ?? item?.value ?? getItemLabel(item));

function HorizontalFilter({ 
  items = [], 
  selectedItem, 
  onSelect, 
  allLabel = "همه",
  className = ""
}) {
  if (!items || items.length === 0) return null;

  const normalizedItems = items.map((item, index) => {
    const value = getItemValue(item);

    return {
      item,
      label: getItemLabel(item),
      value,
      key: `${value}-${index}`
    };
  });

  const selectedValue = useMemo(() => (selectedItem == null ? null : getItemValue(selectedItem)), [selectedItem]);
  const getButtonClassName = (isActive) => `${BASE_BUTTON_CLASS} ${isActive ? ACTIVE_BUTTON_CLASS : INACTIVE_BUTTON_CLASS}`;

  return (
    <div className={`w-full min-w-0 pb-2 ${className}`}>
      <Swiper
        modules={[FreeMode]}
        slidesPerView="auto"
        freeMode
        spaceBetween={8}
        grabCursor
        className="w-full ps-10"
        touchStartPreventDefault={false}
      >
        <SwiperSlide className="!w-auto">
          <button
            type="button"
            onClick={() => onSelect(null)}
            className={getButtonClassName(selectedValue === null)}
          >
            {allLabel}
          </button>
        </SwiperSlide>

        {normalizedItems.map(({ item, label, value, key }) => {
          return (
            <SwiperSlide key={key} className="!w-auto">
              <button
                type="button"
                onClick={() => onSelect(item)}
                className={`${getButtonClassName(selectedValue === value)} cursor-pointer`}
              >
                {label}
              </button>
            </SwiperSlide>
          );
        })}
      </Swiper>
    </div>
  );
}

export default HorizontalFilter;

